import React from 'react';
import propTypes from '@styled-system/prop-types';

import styled from 'styled-components';

import BaseContainer from '../base';

const Column = styled(BaseContainer)`
    width: calc(100vw * (${(props) => props.width[0] ?? 1}));

    ${(props) => props.theme.mediaQueries.tablet} {
        width: calc(100vw * (${(props) => props.width[1] ?? props.width[0] ?? 1}));
    }

    ${(props) => props.theme.mediaQueries.desktop} {
        width: calc(100vw * (${(props) => props.width[2] ?? props.width[1] ?? props.width[0] ?? 1}));
    }

    /* Debug hell */
    /* background-image: linear-gradient(to bottom right, red,orange,yellow,green,blue,indigo,violet); */
`;

const ColumnContainer = (props) => {
    const width = props.width ? props.width : 1;
    return <Column display="inline-flex" flexWrap="wrap" width={width} {...props} />;
};

ColumnContainer.propTypes = {
    ...propTypes.color,
    ...propTypes.space,
    ...propTypes.layout,
    ...propTypes.flexbox,
    ...propTypes.shadow,
    ...propTypes.position,
};

export default ColumnContainer;
